<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditEmployeeDepartment"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full h-screen md:h-auto"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Edit Employee Department</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="() => closeEditDepartment()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="edit_success"
              class="p-1 text-center text-sm w-full bg-green-200"
            >
              {{ edit_success }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="edit_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ edit_error }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1 capitalize">Company</label>
              <el-select
                name=""
                id=""
                v-model="info.Location"
                required
                type="text"
                class="w-full"
                @change="setBranches"
              >
                <el-option
                  v-for="location in saved_locations"
                  :key="location.Id"
                  :value="location.Name"
                >
                  {{ location.Name }}
                </el-option>
              </el-select>
            </div>
            <div class="text-sm">
              <label class="block pb-1 capitalize">Branch</label>
              <el-select
                name=""
                id=""
                v-model="info.Branch"
                required
                type="text"
                class="w-full"
                :disabled="!info.LocationId.length"
                @change="setDepartments"
              >
                <el-option
                  v-for="branch in branchesToSelect"
                  :key="branch.Id"
                  :value="branch.Name"
                >
                  {{ branch.Name }}
                </el-option>
              </el-select>
            </div>

            <div class="text-sm">
              <label class="block pb-1 capitalize">Department</label>
              <el-select
                name=""
                id=""
                v-model="info.Department"
                required
                type="text"
                class="w-full"
                :disabled="!info.BranchId.length"
                @change="() => setJobTitles()"
              >
                <el-option
                  v-for="department in departmentsToSelect"
                  :key="department.DepartmentId"
                  :value="department.Name"
                >
                  {{ department.Name }}
                </el-option>
              </el-select>
            </div>
            <div class="text-sm">
              <label class="block pb-1 capitalize">JobTitle</label>
              <el-select
                name=""
                id=""
                v-model="info.JobTitle"
                required
                type="text"
                class="w-full"
                :disabled="!info.DepartmentId.length"
              >
                <el-option
                  v-for="jobTitle in saved_jobTitles"
                  :key="jobTitle.Id"
                  :value="jobTitle.Name"
                >
                  {{ jobTitle.Name }}
                </el-option>
              </el-select>
            </div>
            <!-- multi-selct-drop-down -->
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
export default {
  name: "EditEmployeeDepartments",
  props: [
    "showEditEmployeeDepartment",
    "info",
    "reload",
    "closeEditDepartment",
  ],
  components: { Loader },
  data() {
    return {
      edit_error: null,
      edit_success: null,
      loading: false,
      saved_locations: [],
      saved_branches: [],
      saved_departments: [],
      saved_jobTitles: [],
      branchesToSelect: [],
      departmentsToSelect: [],
      jobTitlesToSelect: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken", "getCurrentEmployeeId"]),
  },
  created() {
    this.getSavedData();
  },
  methods: {
    setBranches(locationName) {
      this.branchesToSelect = this.saved_branches.filter(
        (branch) => branch.Location === locationName
      );
    },

    setDepartments(branchName) {
      this.departmentsToSelect = this.saved_departments.filter(
        (department) =>
          department.BranchName === branchName &&
          department.LocationName === this.info.Location
      );
    },
    setJobTitles() {
      // //console.log(this.saved_jobTitles)
      // this.jobTitlesToSelect = this.saved_jobTitles.filter(job => job.Name === this.info.)
    },

    // /{organization}/employee/department/v1/edit
    create() {
      this.loading = true;

      let infoToSubmit = {
        EmployeeDepartmentId: "",
        LocationId: "",
        BranchId: "",
        DepartmentId: "",
        JobTitleId: "",
      };
      infoToSubmit.EmployeeDepartmentId = this.info.employeeDepartmentId;
      infoToSubmit.LocationId = this.saved_locations.find(
        (location) => location.Name.trim() === this.info.Location
      ).Id;
      infoToSubmit.BranchId = this.saved_branches.find(
        (branch) => branch.LocationId === infoToSubmit.LocationId
      ).Id;
      infoToSubmit.DepartmentId = this.saved_departments.find(
        (department) => department.Name.trim() === this.info.Department
      ).DepartmentId;
      infoToSubmit.JobTitleId = this.saved_jobTitles.find(
        (job) => job.Name.trim() === this.info.JobTitle
      ).Id;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .put(
          `${this.getOrganization}/employee/department/${this.$ApiVersion}/edit`,
          JSON.stringify(infoToSubmit),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$emit("closeOnSuccess");
              this.edit_success = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_success = null;
                this.reload();
              }, 2500);
            } else {
              this.edit_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
            setTimeout(() => {
              this.edit_error = null;
              this.reload();
            }, 2500);
          }
        );
    },

    getSavedData() {
      this.loading = true;
      let endpoints = [
        `${this.getOrganization}/setup/location/${this.$ApiVersion}/request`,
        `${this.getOrganization}/setup/branch/${this.$ApiVersion}/request`,
        `${this.getOrganization}/setup/department/${this.$ApiVersion}/request`,
        `${this.getOrganization}/setup/jobtitle/${this.$ApiVersion}/request`,
      ];
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      Promise.all(endpoints.map((endpoint) => axios.get(endpoint, options)))
        .then(
          axios.spread((...response) => {
            this.loading = false;
            this.saved_locations = response[0].data.Data;
            this.saved_branches = response[1].data.Data;
            this.saved_departments = response[2].data.Data;
            this.saved_jobTitles = response[3].data.Data;
          })
        )
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
